import type { QueryClient } from "react-query";

import { createQueryKeyFactory } from "./createQueryKeyFactory";
import type { QueryKeyPart } from "./createQueryKeyFactory";

const AUDIENCE_LIST_KEY_SEGMENT = "audience-list";

// Shape: ["newsletters", newsletterId, "posts", "list"|"detail", ...]
export const newslettersKey = createQueryKeyFactory("newsletters");

export const newsletterPostKey = {
  key: <TParts extends readonly QueryKeyPart[]>(
    newsletterId: number,
    ...parts: TParts
  ) => newslettersKey.key(newsletterId, "posts", ...parts),
};

export const newsletterAudienceListKey = {
  key: <TParts extends readonly QueryKeyPart[]>(
    newsletterId: number,
    ...parts: TParts
  ) => newslettersKey.key(newsletterId, AUDIENCE_LIST_KEY_SEGMENT, ...parts),
};

export const newsletterAudienceListContactKey = {
  key: <TParts extends readonly QueryKeyPart[]>(
    newsletterId: number,
    listId: number,
    ...parts: TParts
  ) =>
    newsletterAudienceListKey.key(newsletterId, listId, "contacts", ...parts),
};

export const newsletterAudienceListInvalidations = {
  // Covers the newsletter's audience list queries: list details and counts
  // as well as each list's subscriber table.
  all: (queryClient: QueryClient, newsletterId: number) =>
    queryClient.invalidateQueries({
      queryKey: newsletterAudienceListKey.key(newsletterId),
    }),
};
